import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/solid';
import { Fragment } from 'react';

type Option = {
  id: number;
  title?: string;
};

type Props = {
  options?: Option[];
  selected: Option;
  setSelected: (option: Option) => void;
};

const classNames = (...classes: string[]) => classes.filter(Boolean).join(' ');

const Dropdown = ({ options, selected, setSelected }: Props) => (
  <Listbox value={selected} onChange={setSelected}>
    {({ open }) => (
      <>
        <div className='relative'>
          <Listbox.Button
            className={`bg-main-grey-200 
          relative
          ${open ? 'rounded-t-[4px]' : 'rounded-[4px]'}
          shadow-sm px-3.5 py-1
          text-lg leading-lg font-bold
          sm:text-sm sm:leading-sm
          text-black
          w-[180px]
          pr-[25px]
          sm:w-[130px]
          text-left cursor-default 
          focus:outline-none`}
          >
            <span className='block truncate'>{selected.title}</span>
            <span className='absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none'>
              <ChevronDownIcon className='h-5 w-5 text-black' aria-hidden='true' />
            </span>
          </Listbox.Button>

          <Transition
            show={open}
            as={Fragment}
            leave='transition ease-in duration-100'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <Listbox.Options
              className={`absolute z-10
            w-[180px]
            sm:w-[130px]
            bg-white
            max-h-60 rounded-b-[4px]
            overflow-auto focus:outline-none divide-y-[1px]`}
            >
              {options &&
                options.map((option) => (
                  <Listbox.Option
                    key={option.id}
                    className={({ active }) =>
                      classNames(
                        active ? 'bg-main-grey-300' : 'bg-white',
                        `cursor-default select-none 
                      relative py-2 px-3.5 text-black text-lg leading-lg sm:text-xxs sm:leading-xxs`
                      )
                    }
                    value={option}
                  >
                    {({ selected: current, active }) => (
                      <>
                        <span className={classNames(current ? 'font-semibold' : 'font-normal', 'block truncate')}>
                          {option.title}
                        </span>

                        {current ? (
                          <span
                            className={classNames(
                              active ? 'text-white' : 'text-indigo-600',
                              'absolute inset-y-0 right-0 flex items-center pr-4'
                            )}
                          >
                            <CheckIcon className='h-5 w-5' aria-hidden='true' />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))}
            </Listbox.Options>
          </Transition>
        </div>
      </>
    )}
  </Listbox>
);

export { Dropdown };
